import { LoadingButton } from "@mui/lab"
import { Autocomplete, Box, FormControl, Grid, IconButton, TextField, Typography } from "@mui/material"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { DetailKeyValue } from "../../../../../../components"
import CustomAccordion from "../../../../../../components/accordion"
import { DynamicFormRefValues } from "../../../../../../components/dynamicFormRef/types"
import { QuestionaireVersion } from "../../../../../../service/questionarie/response"
import { icons } from "../../../../../../utils/icons"
import { Item } from "../../../../../../utils/types/generals"
import { useStyles } from "./styles"

const Header = ({
    dataHeader,
    handleNavigate,
    isSectionConfig,
    loadings,
    openGeneralConfig,
    view,
    detail,
    actionPlan,
    averagePoints,
    questionaireVersion,
    handleLastVersionId,
    lastVersionId
}: {
    isSectionConfig: boolean; averagePoints: number; dataHeader: DynamicFormRefValues | undefined; loadings?: {
        main: boolean;
        modal: boolean;
        edit: boolean;
    };
    detail?: {
        id: string | number
        version: string | number
    }
    actionPlan?: boolean
    view: 'permissions' | 'edit' | 'preview' | 'execution'
    openGeneralConfig: () => void, handleNavigate: () => void,
    questionaireVersion?: QuestionaireVersion[],
    handleLastVersionId?: ({ id }: { id: string }) => void,
    lastVersionId?: string
}) => {

    const styles = useStyles()
    const { t } = useTranslation()
    const [open, setOpen] = useState(false)
    const loadVersion = (event: React.ChangeEvent<{}>, newValue: string | null) => {
        if (newValue && handleLastVersionId) {
            handleLastVersionId({ id: newValue });
        }
    };

    return (
        <CustomAccordion
            accordionProps={{
                sx: {
                    '& .MuiAccordionSummary-root.Mui-focusVisible': {
                        backgroundColor: 'white', // Cambia a 'transparent' o el color que prefieras
                    },
                    ...styles.accordion({ view: view == 'permissions' })
                }
            }}
            title={(
                <Box sx={styles.container}>
                    <Box sx={styles.main}>
                        <Box sx={{ flex: '1 0 300px' }}>
                            <Typography sx={{ ...styles.title, wordBreak: 'break-word' }}>{(dataHeader?.quest_name ?? '') as string}</Typography>

                            {!!detail && <Typography variant="footer" fontWeight='500'>#{detail?.id} - {t('general.tags.version')}: {detail?.version}</Typography>}

                            {
                                questionaireVersion && questionaireVersion?.length !== 0 && (
                                    <FormControl sx={styles.formControl}>
                                        <Autocomplete
                                            value={questionaireVersion?.find(version => version.questionnaireMainId === Number(lastVersionId)) || null}
                                            onChange={(event, newValue) => loadVersion(event, newValue ? `${newValue.questionnaireMainId}` : null)}
                                            options={questionaireVersion || []}
                                            getOptionLabel={(option) => `#${option.parentId ? option.parentId : option.questionnaireMainId} - versión ${option.version}`}
                                            renderInput={(params) => <TextField {...params} sx={styles.titleAutocomplete} label={t('Questionarie.fields.listOfVersions')} />}
                                            clearIcon={null}
                                            noOptionsText={t('Questionarie.fields.noOptions')}
                                        />
                                    </FormControl>
                                )
                            }
                        </Box>

                        <Box sx={styles.containerDetail}>
                            <DetailKeyValue
                                name=""
                                value={actionPlan ? t('Questionarie.general') : t('Questionarie.item')}
                                caption="Plan de acción"
                                sxContainer={{ ...styles.keyValue, ...styles.borderRight, ...((view == 'execution' ? styles.withExecution : styles.withoutExecution) as object) }}
                            />

                            <DetailKeyValue
                                name=""
                                value={isSectionConfig ? 'Secciones' : `${averagePoints} / ${dataHeader?.totalPoints}`}
                                caption="Puntaje"
                                sxContainer={{ ...styles.keyValue, ...styles.borderRight, ...((view == 'execution' ? styles.withExecution : styles.withoutExecution) as object) }}

                            />

                            <DetailKeyValue
                                name=""
                                value={(dataHeader?.areas as Item)?.label ?? ''}
                                caption="Área"
                                sxContainer={{ ...styles.keyValue, ...styles.borderRight, ...((view == 'execution' ? styles.withExecution : styles.withoutExecution) as object) }}
                            />

                            <DetailKeyValue
                                name=""
                                value={(dataHeader?.departments as Item)?.label ?? ''}
                                caption="Departamento"
                                sxContainer={{ ...styles.keyValue, ...((view == 'execution' ? styles.withExecution : styles.withoutExecution) as object) }}
                            />
                        </Box>
                    </Box>

                    <Box sx={styles.actions}>
                        {
                            view == 'edit' && (
                                <IconButton onClick={(e) => {
                                    e.stopPropagation()
                                    openGeneralConfig()
                                }}>{icons('setting')}</IconButton>
                            )
                        }

                        {
                            view == 'preview' && (
                                <IconButton onClick={(e) => {
                                    e.stopPropagation()
                                    openGeneralConfig()
                                }}>{icons('search')}</IconButton>
                            )
                        }

                        {
                            view == 'execution' && (
                                <IconButton onClick={(e) => {
                                    e.stopPropagation()
                                    openGeneralConfig()
                                }} sx={styles.settingButton}>{icons('setting')}</IconButton>
                            )
                        }
                        {
                            view !== 'execution' && (
                                <IconButton onClick={() => { setOpen(!open) }}>{icons(!open ? 'fullScreenOpen' : 'fullScreenExit')}</IconButton>
                            )
                        }
                    </Box>

                </Box>
            )}
            expandIcon={null}
            expanded={open}
            onChange={() => { }}
            description={(
                <Box sx={styles.detailContainer}>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Typography sx={styles.title} mb={2}>Descripcion</Typography>

                            <Typography sx={styles.detail}>{dataHeader?.description as string ?? 'N/A'}</Typography>
                        </Grid>

                        <Grid item xs={6}>
                            <Typography sx={styles.title} mb={2}>Instrucciones</Typography>

                            <Typography sx={styles.detail}>{dataHeader?.instruction as string ?? 'N/A'}</Typography>
                        </Grid>
                    </Grid>

                    {view == 'edit' && <LoadingButton loading={loadings?.edit} sx={{ marginTop: 2 }} className="button-1" onClick={handleNavigate} variant="contained">Editar</LoadingButton>}
                </Box>
            )}
        />
    )
}

export { Header }
